import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.growth-scale-form', () => {
  void import('./internal/growth-scale-form').then(({ default: Component }) => Component());
});
